module.exports = __webpack_public_path__ + "static/img/37-中国人民大学附属小学.de87630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/37-中国人民大学附属小学.png
// module id = 2sqI
// module chunks = 0